module.exports = __webpack_public_path__ + "img/ditiepiao.3b965e09.png";